import styled from 'styled-components';

import {
  colorGrey200,
  colorGrey400,
  colorPrimary400,
  colorWhite,
  fontFamilyPrimary,
} from '@/styleUtils';

export const Wrapper = styled.label`
  position: relative;
  display: block;
  width: 100%;
`;

export const Placeholder = styled.span`
  font: 400 16px/100% ${fontFamilyPrimary};
  background-color: ${colorWhite};
  color: ${({ $forceColor }) => $forceColor || colorGrey400};
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(12px, 16px);
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  z-index: 1;

  input:focus + & {
    color: ${colorPrimary400};
  }

  input:focus + &,
  input[data-empty='false'] + & {
    padding: 0 4px;
    transform: translate(2px, -8px) scale(0.75);
    letter-spacing: 0.36px;
  }
`;

export const InputField = styled.input`
  appearance: textfield;
  background-color: ${colorWhite};
  box-shadow: inset 0 0 0 1px ${colorGrey200};
  border-radius: 4px;
  font: 400 16px/100% ${fontFamilyPrimary};
  outline: none;
  padding: 10px 12px;
  width: 100%;
  height: 48px;
  transition: 0.8s;

  &:focus,
  &:hover,
  &:active,
  &:focus-visible {
    cursor: pointer;
    box-shadow: inset 0 0 0 2px ${colorPrimary400};
  }
`;
